(function () {
  'use strict';

  var CART_OPEN_CLASS = 's2g-drawer-open';
  var MENU_OPEN_CLASS = 's2g-mobile-menu-open';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function moveToBody(el) {
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  }

  function lockPage() {
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    document.documentElement.style.touchAction = 'auto';
    document.body.style.touchAction = 'auto';
  }

  function unlockPageIfClosed() {
    if (!isCartOpen() && !isMenuOpen()) {
      document.documentElement.classList.remove('overflow-hidden', CART_OPEN_CLASS, MENU_OPEN_CLASS);
      document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'stick', CART_OPEN_CLASS, MENU_OPEN_CLASS);
      document.documentElement.style.touchAction = '';
      document.body.style.touchAction = '';
    }
  }

  function openCartDrawer() {
    var oldDrawer = qs('.cart-content');
    var overlay = qs('.overlay');

    moveToBody(oldDrawer);
    moveToBody(overlay);

    document.documentElement.classList.add(CART_OPEN_CLASS);
    document.body.classList.add(CART_OPEN_CLASS, 'stick');
    lockPage();

    if (oldDrawer) {
      oldDrawer.classList.add('active');
      oldDrawer.style.position = 'fixed';
      oldDrawer.style.top = '0';
      oldDrawer.style.right = '0';
      oldDrawer.style.bottom = '0';
      oldDrawer.style.left = 'auto';
      oldDrawer.style.height = '100dvh';
      oldDrawer.style.maxHeight = '100dvh';
      var reload = oldDrawer.querySelector('#cart_reload');
      if (reload) {
        reload.style.overflowY = 'auto';
        reload.style.webkitOverflowScrolling = 'touch';
        reload.style.minHeight = '0';
      }
      oldDrawer.style.zIndex = '2147483600';
      oldDrawer.style.transform = 'translateX(0)';
    }
    if (overlay) {
      overlay.classList.add('overlay_active');
      overlay.style.backdropFilter = 'none';
      overlay.style.webkitBackdropFilter = 'none';
      overlay.style.filter = 'none';
    }
  }

  function closeCartDrawer() {
    var oldDrawer = qs('.cart-content');
    var overlay = qs('.overlay');
    if (oldDrawer) oldDrawer.classList.remove('active');
    if (overlay) overlay.classList.remove('overlay_active');
    document.documentElement.classList.remove(CART_OPEN_CLASS);
    document.body.classList.remove(CART_OPEN_CLASS, 'stick');
    unlockPageIfClosed();
  }

  function isCartOpen() {
    return !!(qs('.cart-content.active') || qs('cart-drawer.active'));
  }

  function isMenuOpen() {
    return !!(qs('.menu-drawer-container[open]') || qs('.menu-drawer-container.menu-opening'));
  }

  function syncMenuState() {
    if (isMenuOpen()) {
      document.documentElement.classList.add(MENU_OPEN_CLASS);
      document.body.classList.add(MENU_OPEN_CLASS, 'overflow-hidden-mobile');
      lockPage();
    } else {
      document.documentElement.classList.remove(MENU_OPEN_CLASS);
      document.body.classList.remove(MENU_OPEN_CLASS, 'overflow-hidden-mobile');
      unlockPageIfClosed();
    }
  }

  function insideAllowedScroller(target) {
    return !!(target && target.closest && target.closest(
      '.cart-content, .cart-content #cart_reload, .cart-content .cart_content, .cart-content .cart-block-content, .cart-content .cart_content-block, ' +
      'cart-drawer, cart-drawer-items, .drawer__inner, .drawer__contents, ' +
      '#base_mega_menu.responsive-menu .menu-drawer, #base_mega_menu.responsive-menu .menu-drawer__navigation, #base_mega_menu.responsive-menu .menu-drawer__navigation-container, ' +
      '.menu-drawer, .menu-drawer__navigation, .menu-drawer__navigation-container, .menu-drawer__inner-container, .menu-drawer__inner-submenu'
    ));
  }

  function blockPageScroll(e) {
    if (!isCartOpen() && !isMenuOpen()) return;
    // Allow native wheel/touch scrolling inside the cart item list and mobile menu.
    // The page behind is locked with overflow-hidden, so only outside gestures are blocked.
    if (insideAllowedScroller(e.target)) return;
    e.preventDefault();
  }

  document.addEventListener('DOMContentLoaded', function () {
    moveToBody(qs('.cart-content'));
    moveToBody(qs('.overlay'));

    document.addEventListener('click', function (e) {
      var cartTrigger = e.target.closest && e.target.closest('.cart-wrapper, #cart-icon-bubble, .header__icon--cart');
      if (cartTrigger && qs('.cart-content')) {
        setTimeout(openCartDrawer, 0);
      }

      if (e.target.closest && e.target.closest('.close-icon, .overlay.overlay_active')) {
        closeCartDrawer();
      }

      setTimeout(syncMenuState, 30);
    }, true);

    qsa('.menu-drawer-container').forEach(function (el) {
      new MutationObserver(syncMenuState).observe(el, { attributes: true, attributeFilter: ['open', 'class'] });
    });
    syncMenuState();
  });

  // Do not re-open/reposition the cart drawer on scroll; it is fixed in CSS.

  document.addEventListener('wheel', blockPageScroll, { passive: false });
  document.addEventListener('touchmove', blockPageScroll, { passive: false });
})();

/* S2G final sizing helper: keeps checkout/view basket visible and item list scrollable after AJAX cart reloads. */
(function () {
  function fitCartDrawer() {
    var drawer = document.querySelector('body .cart-content');
    if (!drawer) return;
    var header = drawer.querySelector('.top-block-cart');
    var response = drawer.querySelector('.qv-add-to-cart-response');
    var reload = drawer.querySelector('#cart_reload');
    var listWrap = drawer.querySelector('.cart-block-content');
    var list = drawer.querySelector('.cart_content-block');
    var summary = drawer.querySelector('.cart-summary');
    var actions = drawer.querySelector('.cart-viewcart');
    if (!reload || !listWrap || !list) return;

    drawer.style.height = '100dvh';
    drawer.style.maxHeight = '100dvh';
    drawer.style.overflow = 'hidden';
    reload.style.overflow = 'hidden';
    reload.style.minHeight = '0';
    listWrap.style.minHeight = '0';
    listWrap.style.overflow = 'hidden';
    list.style.overflowY = 'auto';
    list.style.webkitOverflowScrolling = 'touch';
    list.style.minHeight = '0';

    var viewport = window.innerHeight || document.documentElement.clientHeight || 700;
    var used = 0;
    [header, response, summary, actions].forEach(function (el) {
      if (el && el.offsetParent !== null) used += el.getBoundingClientRect().height || 0;
    });
    var max = Math.max(140, viewport - used - 8);
    listWrap.style.maxHeight = max + 'px';
    list.style.maxHeight = max + 'px';
  }

  window.S2GCartDrawerFix = fitCartDrawer;
  document.addEventListener('DOMContentLoaded', fitCartDrawer);
  window.addEventListener('resize', fitCartDrawer);
  document.addEventListener('click', function () { setTimeout(fitCartDrawer, 80); }, true);
  document.addEventListener('shopify:section:load', fitCartDrawer);
  var mo = new MutationObserver(function () { setTimeout(fitCartDrawer, 30); });
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('body .cart-content');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  });
})();
